<template>
	<Col class="height-100">
		<Row class="flex-align-center my-3">
			<AnemicButton @click="goBack" class="back-button mr-1" width="25" height="25" fab x-small>
				<SIcon class="arrow-icon mt-n1" name="back" />
			</AnemicButton>
			<h5>Back</h5>
		</Row>
		<TaskLogInfo
			:flowRunId="taskLogId"
			:allowInnerScroll="false"
			:clearAfterDestroy="false"
			class="width-100 height-100"
			:showEditFeatureLink="false"
		>
			<template #loader>
				<AppLoader class="mt-5" />
			</template>
		</TaskLogInfo>
	</Col>
</template>
<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import TaskLogInfo from '@/components/TaskLog/TaskLogInfo.vue';
import { closeSideBar } from '@/store/modules/selectedNode/actions';
import { BUILDER_DEBUG_MODE_ROUTE_NAME, BUILDER_TASK_LOG_INNER_PAGE } from '@/router/router.const.js';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service';
import { clearTask } from '@/store/modules/analytics/actions';
export default {
	name: BUILDER_TASK_LOG_INNER_PAGE,
	components: { TaskLogInfo },
	props: {
		taskLogId: { type: String, required: true },
	},
	computed: {},
	methods: {
		...mapActionsShorthand({ closeSideBar, clearTask }),
		goBack() {
			this.closeSideBar();
			this.$router.push({ name: BUILDER_DEBUG_MODE_ROUTE_NAME });
		},
	},
	created() {
		if (!this.taskLogId) {
			WorkflowVersionService.closeLeftSideDrawerSpecialRouterView(this.$router);
		}
	},
	data() {
		return {};
	},
	beforeDestroy() {
		this.clearTask();
	},
};
</script>
<style scoped lang="scss">
.back-button {
	background: #eceff4 !important;
	border: 1px solid #e0e0e0 !important;
}
</style>
